// @ts-check
/**
 * Papéis — espelho de `server/src/lib/roles.js`.
 *
 * O cliente usa isto só para desenhar a interface (mostrar ou esconder um
 * botão). A decisão que vale é sempre a do servidor: esconder um botão não
 * é segurança, é conveniência.
 */

export const PLATFORM_ROLES = ["master_owner", "master_admin", "master_cs", "master_support"];
export const CLINIC_ROLES = ["admin", "gestor", "dentista", "atendente"];

export const ROLE_LABELS = {
  master_owner: "Proprietário",
  master_admin: "Administrador",
  master_cs: "Customer Success",
  master_support: "Suporte",
  admin: "Administrador",
  gestor: "Gestor",
  dentista: "Dentista",
  atendente: "Atendente",
};

/** Opções do seletor de papel ao criar um usuário da clínica. */
export const CLINIC_ROLE_OPTIONS = CLINIC_ROLES.map((valor) => ({
  value: valor,
  label: ROLE_LABELS[valor],
}));

/** Opções do seletor de papel ao criar um usuário Master. */
export const PLATFORM_ROLE_OPTIONS = PLATFORM_ROLES.map((valor) => ({
  value: valor,
  label: ROLE_LABELS[valor],
}));

export const isPlatformRole = (role) => PLATFORM_ROLES.includes(role);
export const CLINIC_ADMIN_ROLES = ["admin", "gestor"];
export const MASTER_WRITE_ROLES = ["master_owner", "master_admin", "master_cs"];

/** @param {{ role: string } | null} user */
export const canManageUsers = (user) =>
  Boolean(user) && [...CLINIC_ADMIN_ROLES, ...PLATFORM_ROLES].includes(user.role);

/** @param {{ role: string } | null} user */
export const canWriteMaster = (user) => Boolean(user) && MASTER_WRITE_ROLES.includes(user.role);
